/// <reference types="vite/client" />
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ar from './locales/ar.json'

// Per-page locale files (added incrementally as pages are translated) — each file
// contributes one or more top-level namespace keys (e.g. { "trainers": {...} }).
// Using import.meta.glob keeps this file from needing a manual import per page,
// so translators can just drop a new pair of files in locales/pages/ and go.
const enPageModules = import.meta.glob('./locales/pages/*.en.json', { eager: true, import: 'default' }) as Record<string, Record<string, unknown>>
const arPageModules = import.meta.glob('./locales/pages/*.ar.json', { eager: true, import: 'default' }) as Record<string, Record<string, unknown>>

function mergePages(base: Record<string, unknown>, modules: Record<string, Record<string, unknown>>) {
  return Object.values(modules).reduce((acc, mod) => ({ ...acc, ...mod }), { ...base })
}

const enResource = mergePages(en, enPageModules)
const arResource = mergePages(ar, arPageModules)

const initialLang = localStorage.getItem('drivys-lang') || 'en'

i18n.use(initReactI18next).init({
  resources: { en: { translation: enResource }, ar: { translation: arResource } },
  lng: initialLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

// Apply the document direction + lang on load and on every language change, so a
// page refresh keeps Arabic (RTL) instead of resetting to LTR.
function applyDir(lng: string) {
  if (typeof document === 'undefined') return
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.lang = lng
}
applyDir(initialLang)
i18n.on('languageChanged', applyDir)

export default i18n
